import React, {Component} from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './FetchAllApps.css';

var JsonFileDiv = document.createElement("DIV");
JsonFileDiv.setAttribute("id", "JsonFile");
document.getElementsByTagName('body')[0].appendChild(JsonFileDiv);

let pssParams = window.pss_params;

let apiURL = document.location.host;
//let apiURL = 'localhost/RiverCity';

let presales_site_url = 'demos-sp-ocl-ug';
let presales_site_master = 'DEMO_NSW';
let presales_site_compliance = 'DEMO_NSW';
let presales_site_request = 'DEMO_NSW';
let presales_site_portal_name = 'PRONLINESERVICE';
let presales_site_portal_suite = 'PR';
let presales_site_asset_register = 'ASSET';

if (pssParams) {
    presales_site_url = pssParams.presales_site_url;
    presales_site_master = escape(pssParams.presales_site_master);
    presales_site_compliance = escape(pssParams.presales_site_compliance);
    presales_site_request = escape(pssParams.presales_site_request);
    presales_site_portal_name = escape(pssParams.presales_site_portal_name);
    presales_site_portal_suite = escape(pssParams.presales_site_portal_suite);
    presales_site_asset_register = escape(pssParams.presales_site_asset_register);
}

let allAppsURL = `https://${apiURL}/wp-json/presalessettings/v1/fetchapplications`;
let myData = [];

class FetchAllApps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appsJson: [],
            selectedOption: '', 
        } 
    }

    handleChange = (selectedOption) => {
        if (selectedOption) {
            // set the display value
            this.setState({
                selectedOption
            });

            //console.log(`Selectedin FetchAllApps: ${selectedOption.value} : ${selectedOption.label}`);
            this.props.allAppsCallBackFromParent(selectedOption.value);
        } else {
             this.setState({
                selectedOption: '',
             });
        }
    }

    componentDidMount () {
        fetch(allAppsURL).then(response => {
            let contentType = response.headers.get("Content-Type");
            if (contentType && contentType.includes("application/json")) {
                return response.json();
            }
            throw new TypeError("Oops, we haven't got JSON!");
        }).then(json => {
            let jsonData = JSON.stringify(json, ['DataSet', 'ApplicationId', 'PrimaryPropertyAddress', 'FileId'], 2);
            jsonData = jsonData.replace(/"ApplicationId":/g, "\"value\":");
            jsonData = jsonData.replace(/"PrimaryPropertyAddress":/g, "\"label\":");
            jsonData = jsonData.replace(/"FileId":/g, "\"FileId\":");
            myData = JSON.parse(jsonData);

            //Set label to include FileId
            Object.keys(myData.DataSet).forEach((key) => {
                let newLabel = myData.DataSet[key].FileId + " - " + myData.DataSet[key].label;
                myData.DataSet[key].label = newLabel;
            });

            //this.applicationDisplay(myData);
            // return just the dataset object
            this.setState ({
                appsJson: myData.DataSet,
            })
        });
    }

    applicationDisplay(appJson) {
        // use this line to display the Json we got back for testing / verification
        if (appJson !== '') {
            document.getElementById("JsonFile").innerHTML = "<pre>" + JSON.stringify(appJson, 0, 4) + "</pre>";
        } else {
            document.getElementById("JsonFile").innerHTML = "<pre></pre>";
        }
    }

    render () {
        return (
                <Select
                name = "select-application-list"
                value = {this.state.selectedOption}
                onChange = {this.handleChange}
                options = {this.state.appsJson}
                selected = {this.state.selectedOption}
                isSearchable = {true}
                />
        );
    }
}

export default FetchAllApps;




// WEBPACK FOOTER //
// ./src/FetchAllApps.js